import { render, staticRenderFns } from "./RoomExamLoading.vue?vue&type=template&id=27e1efd5&"
import script from "./RoomExamLoading.vue?vue&type=script&lang=js&"
export * from "./RoomExamLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e1efd5')) {
      api.createRecord('27e1efd5', component.options)
    } else {
      api.reload('27e1efd5', component.options)
    }
    module.hot.accept("./RoomExamLoading.vue?vue&type=template&id=27e1efd5&", function () {
      api.rerender('27e1efd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/View/RoomExamLoading.vue"
export default component.exports